import { motion } from "framer-motion";
import { Bot, FileText, CalendarCheck } from "lucide-react";

const CHAPTERS = [
  {
    n: "01",
    icon: Bot,
    title: "Automazione operativa",
    body: "ManyChat per risposte automatiche, trascrizione delle riunioni con Zoom AI, assistenza clienti e FAQ, prenotazioni senza avanti e indietro: l'AI che libera il tuo tempo.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Contenuti e comunicazione",
    body: "Descrizioni post ottimizzate SEO, email, preventivi e follow-up automatici, schemi e mappe: crea contenuti efficaci e gestisci la comunicazione senza fatica.",
  },
  {
    n: "03",
    icon: CalendarCheck,
    title: "Piano d'azione in 30 giorni",
    body: "Una roadmap settimanale, checklist pratiche ed errori da evitare per integrare l'AI nella tua attività passo dopo passo, dal giorno 1 fino ai primi risultati.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export const WhySection = () => {
  return (
    <section className="px-6 py-24 sm:px-10 lg:px-16 lg:py-32" data-testid="why-section">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-16 max-w-2xl"
        >
          <span className="text-[0.7rem] font-semibold uppercase tracking-[0.32em] text-[#a78bfa]">
            Perché questa guida?
          </span>
          <h2 className="mt-5 text-3xl font-light leading-tight sm:text-4xl lg:text-5xl">
            Tre capitoli per trasformare il modo in cui lavori.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#27272a] bg-[#27272a] md:grid-cols-3">
          {CHAPTERS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.n}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                className="group relative bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#0d0b16] lg:p-10"
                data-testid={`chapter-${c.n}`}
              >
                <div className="flex items-start justify-between">
                  <span className="text-6xl font-black text-[#1c1c20] transition-colors duration-500 group-hover:text-[#7c3aed]/40 lg:text-7xl">
                    {c.n}
                  </span>
                  <Icon className="h-7 w-7 text-[#a78bfa]" strokeWidth={1.5} />
                </div>
                <h3 className="mt-8 text-xl font-bold lg:text-2xl">{c.title}</h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-[#a1a1aa]">
                  {c.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
